import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { hydrateCopyObjectWithEntity } from "../../state/reducers/locale/copyUtils.js";

import ConfirmationModal from "./ConfirmationModal.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";
import { isUndefined } from "lodash";

function withConfirmationModal(WrappedComponent) {
  class WithConfirmationModal extends PureComponent {
    static propTypes = {
      copy: PropTypes.func.isRequired
    };

    constructor(props) {
      super(props);

      this.state = {
        showModal: false,
        modalCopy: {},
        modalConfirmedCallback: null,
        modalChildren: null
      };
    }

    // -- MODAL -- //

    openModal = (
      callback,
      copyKey,
      copyObj = undefined,
      entity = undefined,
      children = undefined
    ) => {
      const { copy } = this.props;
      const modalConfirmedCallback = callback;
      const modalCopy = hydrateCopyObjectWithEntity(
        copyObj || copy(copyKey),
        entity
      );

      this.setState({
        showModal: true,
        modalConfirmedCallback,
        modalCopy,
        modalChildren: children
      });
    };

    closeModal = confirmed => {
      const { modalConfirmedCallback } = this.state;

      if (confirmed === true) modalConfirmedCallback();

      this.setState({ showModal: false });
    };

    render() {
      return (
        <Fragment>
          <WrappedComponent
            {...this.props}
            openModal={this.openModal}
            closeModal={this.closeModal}
          />
          <ConfirmationModal
            open={this.state.showModal}
            onClose={this.closeModal}
            copy={this.state.modalCopy}
          >
            {this.state.modalChildren}
          </ConfirmationModal>
        </Fragment>
      );
    }
  }

  WithConfirmationModal.displayName = `WithConfirmationModal(${getDisplayName(
    WrappedComponent
  )})`;

  return connect(mapStateToProps)(WithConfirmationModal);
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default withConfirmationModal;
